import React, {Component} from "react";
import axios from "../../../axios";
import qs from "qs";
import Alert from "react-s-alert";
import {status_aktif} from "../../../constants/general";
import {
    SCHEDULE_LIST,
    CATEGORY_LIST,
    SCHEDULE_SUBMIT_ADD,
    SCHEDULE_SUBMIT_EDIT
} from "../endpoints";
import DropdownView from "./DropdownView";
import InputView from "./InputView";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import {connect} from "react-redux";
import FormDropdown from "../../../components/FormDropdown";
import Switch from "react-switch";

class Forms extends Component {
    constructor(props) {
        super(props);

        this.state = {
            exam_cat_id: "",
            mapel_id: "",
            exam_title: "",
            exam_desc: "",
            exam_type: "",
            exam_random: "",
            exam_start_date: "",
            exam_end_date: "",
            exam_start_date_moment: null,
            exam_end_date_moment: null,
            exam_time_limit: "",
            temp_exam_time_limit: "",
            participants: "",
            exam_status: "",
            user_id: "",
            dataKelas: [],
            dataGuru: [],
            kelas: [],
            kelasNew: [],
            dataMapel: [],
            dataKategori: [],
            isButtonLoading: false,
            isLoadingDataKelas: false,
            isLoadingDataMapel: false,
            isLoadingDataKategori: false,
            isLoading: false,
            showNilai:false,
            showResult:false

        };

        this.handleChangeSwitch = this.handleChangeSwitch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);
        this.handleDatepickerStartChange = this.handleDatepickerStartChange.bind(
            this
        );
        this.handleDatepickerEndChange = this.handleDatepickerEndChange.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        if (value === "alltime") {
            this.setState({exam_time_limit:""})
        } else if (value === "ontime") {
            this.setState({exam_time_limit:this.state.temp_exam_time_limit})
        }
        this.setState({
            [name]: value
        });
    }

    handleChangeSwitch(e, f) {
        const name = f;
        this.setState({
            [name]: e
        },()=>{
            console.log(this.state.showNilai)
        });
    }

    handleChangeMultiSelect(stateName, text) {
        this.setState({[stateName]: text});

        if (stateName == 'participants') {
            const kelasNew = text.map(item => ({
                "kelas_id": item.value
            }));

            this.setState({
                kelasNew
            });
        }

    }

    handleSubmit() {
        this.setState({isButtonLoading: true});
        const url = this.props.mode === "Tambah" ? '/exam/create' : '/exam/update';

        const paramsData = {
            locale: "id",
            platform: "web",
            exam_cat_id: this.state.exam_cat_id,
            mapel_id: this.state.mapel_id,
            user_id: this.state.user_id,
            exam_title: this.state.exam_title,
            exam_desc: this.state.exam_desc,
            exam_type: this.state.exam_type,
            exam_random: this.state.exam_random,
            exam_start_date: this.state.exam_start_date,
            exam_end_date: this.state.exam_end_date,
            exam_time_limit: this.state.exam_time_limit,
            kelas: this.state.kelasNew,
            exam_id: this.props.match.params.exam_id,
            exam_status: this.state.exam_status,
            showNilai:this.state.showNilai ? '1' : '0',
            showResult:this.state.showResult ? '1' : '0'
        };

        let checkParamsDataIsEmpty = this.checkParamsData(paramsData)
        if (checkParamsDataIsEmpty) {
            this.setState({ isButtonLoading: false });
            return;
        }

        axios({
            method: "post",
            url: url,
            data: qs.stringify(paramsData)
        })
            .then(response => {
                const result = response.data;

                if (result.status) {
                    Alert.success(result.text);
                    this.props.history.replace("/exam/schedule");
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }
                    this.setState({isButtonLoading: false});
                }
            })
            .catch(error => {
                console.log(error);
                Alert.error("Gagal terhubung ke server!");
                this.setState({isButtonLoading: false});
            });
    }

    checkParamsData(paramsData){
        let msgError = ""
        switch (0) {
            case paramsData.exam_cat_id.length:
                msgError = "Kolom kategori belum dipilih";
                Alert.error(msgError);
                break;
            case paramsData.user_id.length:
                msgError = "Kolom guru belum dipilih";
                Alert.error(msgError);
                break;
            case paramsData.mapel_id.length:
                msgError = "Kolom mata pelajaran belum dipilih";
                Alert.error(msgError);
                break;
            case paramsData.exam_title.length:
                msgError = "Kolom judul belum di isi";
                Alert.error(msgError);
                break;
            case paramsData.exam_desc.length:
                msgError = "Kolom keterangan belum di isi";
                Alert.error(msgError);
                break;
            case paramsData.exam_type.length:
                msgError = "Kolom pewaktu ujian belum dipilih";
                Alert.error(msgError);
                break;
            case paramsData.exam_random.length:
                msgError = "Kolom soal acak belum dipilih";
                Alert.error(msgError);
                break;
            case paramsData.exam_start_date.length:
                msgError = "Kolom waktu mulai belum dipilih";
                Alert.error(msgError);
                break;
            case paramsData.exam_end_date.length:
                msgError = "Kolom waktu berakhir belum dipilih";
                Alert.error(msgError);
                break;
            case paramsData.exam_time_limit.length:
                msgError = "Kolom waktu (dalam menit) belum di isi";
                Alert.error(msgError);
                break;
            case paramsData.kelas.length:
                msgError = "Kolom kelas belum dipilih";
                Alert.error(msgError);
                break;
            default: 
                msgError = "";
                break;
        }
        if (msgError !== "") {
          return true;
        } else {
          return false;
        }
      }

    handleDatepickerStartChange(date) {
        if (date !== null) {
            this.setState({
                exam_start_date_moment: date,
                exam_start_date: date.format("YYYY-MM-DD HH:mm") + ":00"
            });
            let duration, minute;
            if (this.state.exam_end_date_moment) {
                duration = moment.duration(this.state.exam_end_date_moment.diff(date));
                minute = duration.asMinutes();
            }
            if (this.state.exam_type !== "alltime") {
                this.setState({exam_time_limit:minute})
            }
            this.setState({temp_exam_time_limit:minute})
        } else {
            this.setState({exam_start_date: ""});
        }
    }

    handleDatepickerEndChange(date) {
        if (date !== null) {
            this.setState({
                exam_end_date_moment: date,
                exam_end_date: date.format("YYYY-MM-DD HH:mm") + ":00"
            });
            let duration, minute;
            if (this.state.exam_start_date_moment) {
                duration = moment.duration(date.diff(this.state.exam_start_date_moment));
                minute = duration.asMinutes();
            }
            if (this.state.exam_type !== "alltime") {
                this.setState({exam_time_limit:minute})
            }
            this.setState({temp_exam_time_limit:minute})
        } else {
            this.setState({exam_end_date: ""});
        }
    }

    loadData() {
        if (this.props.mode === "Edit") {
            this.setState({isLoading: true});

            const params = qs.stringify({
                exam_id: this.props.match.params.exam_id
            })

            axios({
                method: "post",
                url: "/ujian/" + this.props.match.params.exam_id + "?" + params
            })

                .then(response => {
                    const result = response.data;

                    if (result.success) {
                        let newState = {
                            exam_cat_id: result.data.exam_cat_id,
                            mapel_id: result.data.mapel_id,
                            user_id: result.data.user_id,
                            exam_title: result.data.exam_title,
                            exam_desc: result.data.exam_desc,
                            exam_type: result.data.exam_type,
                            exam_status: result.data.exam_status,
                            exam_random: result.data.exam_random,
                            exam_start_date: result.data.exam_start_date,
                            exam_end_date: result.data.exam_end_date,
                            exam_start_date_moment: moment(result.data.exam_start_date),
                            exam_end_date_moment: moment(result.data.exam_end_date),
                            exam_time_limit: result.data.exam_time_limit,
                            kelas: result.part,
                            showNilai:result.data.exam_show_score === '1' ? true : false,
                            showResult:result.data.exam_show_result  === '1' ? true : false
                        };

                        const participants = result.part.map(
                            item => item.kelas_id
                        );

                        const kelasNew = result.part.map(item => ({
                            "kelas_id": item.kelas_id
                        }));

                        newState.participants = participants.join(",");
                        newState.kelasNew = kelasNew

                        this.setState(newState);
                    } else {
                        Alert.error(result.message, {
                            position: 'bottom-right',
                            effect: 'slide',
                            timeout: 'none'
                        });
                    }

                    this.setState({isLoading: false});
                })
                .catch(error => {
                    console.log(error);
                    Alert.error("Gagal terhubung ke server!", {
                        position: 'bottom-right',
                        effect: 'slide',
                        timeout: 'none'
                    });
                    this.setState({isLoading: false});
                });
        }
    }

    loadDataKategori() {
        this.setState({isLoadingDataKategori: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })

        axios({
            method: 'post',
            url: '/exam/category-mapel-kelas?' + params
        })

            .then(response => {
                const result = response.data;

                if (result.status) {
                    const dataKategori = result.data.category.map(item => ({
                        value: item.exam_cat_id,
                        label: item.exam_cat_name
                    }));

                    this.setState({
                        dataKategori,
                        isLoadingDataKategori: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({isLoadingDataKategori: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataKategori: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataMapel() {
        this.setState({isLoadingDataMapel: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })

        axios({
            method: 'post',
            url: '/exam/category-mapel-kelas?' + params
        })

            .then(response => {
                const result = response.data;
                if (result.status) {
                    const dataMapel = result.data.mapel.map(item => ({
                        value: item.mapel_id,
                        label: item.mapel_nama
                    }));

                    this.setState({
                        dataMapel,
                        isLoadingDataMapel: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item, {
                                position: 'bottom-right',
                                effect: 'slide',
                                timeout: 'none'
                            });

                            return true;
                        });
                    } else {
                        Alert.error(result.text, {
                            position: 'bottom-right',
                            effect: 'slide',
                            timeout: 'none'
                        });
                    }

                    this.setState({isLoadingDataMapel: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataMapel: false});
                Alert.error("Gagal terhubung ke server!", {
                    position: 'bottom-right',
                    effect: 'slide',
                    timeout: 'none'
                });
            });
    }

    loadDataKelas() {
        this.setState({isLoadingDataKelas: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })

        axios({
            method: 'post',
            url: '/exam/category-mapel-kelas?' + params
        })

            .then(response => {
                const result = response.data;
                if (result.status) {
                    const dataKelas = result.data.kelas.map(item => ({
                        value: item.kelas_id,
                        label: item.kelas_nama
                    }));

                    this.setState({
                        dataKelas,
                        isLoadingDataKelas: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({isLoadingDataKelas: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataKelas: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataGuru() {
        this.setState({isLoadingDataGuru: true});

        const params = qs.stringify({
            level: "guru"
        })

        axios({
            method: 'post',
            url: '/user?' + params
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    const dataGuru = result.data.map(item => ({
                        value: item.user_id,
                        label: item.user_nama
                    }));

                    this.setState({
                        dataGuru,
                        isLoadingDataGuru: false
                    });
                } else {
                    if (Array.isArray(result.message)) {
                        result.message.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({isLoadingDataGuru: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataGuru: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

    componentDidMount() {
        this.loadData();
        this.loadDataKelas();
        this.loadDataKategori();
        this.loadDataMapel();
        this.loadDataGuru();
    }

    render() {
        return (
            <div className="card">
                <div className="card-header">{this.props.mode} Kategori Ujian</div>
                <div className="card-block">
                    {this.state.isLoading ? (
                        "Memuat Data..."
                    ) : (
                        <div className="form-horizontal animated fadeIn">
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Kategori</label>
                                <div className="col-md-10">
                                    <Select
                                        placeholder="- Pilih Kategori"
                                        name="exam_cat_id"
                                        simpleValue
                                        value={this.state.exam_cat_id}
                                        clearable={false}
                                        onChange={text =>
                                            this.handleChangeMultiSelect("exam_cat_id", text)
                                        }
                                        options={this.state.dataKategori}
                                        isLoading={this.state.isLoadingDataKategori}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Guru</label>
                                <div className="col-md-10">
                                    <Select
                                        placeholder="- Pilih Guru"
                                        name="user_id"
                                        simpleValue
                                        value={this.state.user_id}
                                        clearable={false}
                                        onChange={text =>
                                            this.handleChangeMultiSelect("user_id", text)
                                        }
                                        options={this.state.dataGuru}
                                        isLoading={this.state.isLoadingDataGuru}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">
                                    Mata Pelajaran
                                </label>
                                <div className="col-md-10">
                                    <Select
                                        placeholder="- Pilih Mata Pelajaran"
                                        name="mapel_id"
                                        simpleValue
                                        value={this.state.mapel_id}
                                        clearable={false}
                                        onChange={text =>
                                            this.handleChangeMultiSelect("mapel_id", text)
                                        }
                                        options={this.state.dataMapel}
                                        isLoading={this.state.isLoadingDataMapel}
                                    />
                                </div>
                            </div>
                            <InputView
                                handleChange={this.handleChange}
                                stateName="exam_title"
                                label="Judul"
                                value={this.state.exam_title}
                            />
                            <InputView
                                handleChange={this.handleChange}
                                stateName="exam_desc"
                                label="Keterangan"
                                value={this.state.exam_desc}
                                type="textarea"
                            />
                            <DropdownView
                                handleChange={this.handleChange}
                                stateName="exam_type"
                                label="Pewaktuan Ujian"
                                placeholder={"- Pilih Pewaktuan Ujian"}
                                items={[
                                    {key: "ontime", value: "Satu Waktu Tertentu"},
                                    {key: "alltime", value: "Bebas"}
                                ]}
                                value={this.state.exam_type}
                            />
                            <DropdownView
                                handleChange={this.handleChange}
                                stateName="exam_random"
                                label="Soal Acak"
                                placeholder={"- Pilih Soal Acak"}
                                items={[
                                    {key: "0", value: "Tidak"},
                                    {key: "1", value: "Iya"}
                                ]}
                                value={this.state.exam_random}
                            />
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">
                                    Waktu Mulai
                                </label>
                                <div className="col-md-10">
                                    <DatePicker
                                        selected={this.state.exam_start_date_moment}
                                        selectsStart
                                        startDate={this.state.exam_start_date_moment}
                                        endDate={this.state.exam_end_date_moment}
                                        onChange={this.handleDatepickerStartChange}
                                        dateFormat="DD-MM-YYYY HH:mm"
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">
                                    Waktu Selesai
                                </label>
                                <div className="col-md-10">
                                    <DatePicker
                                        selected={this.state.exam_end_date_moment}
                                        selectsEnd
                                        startDate={this.state.exam_start_date_moment}
                                        endDate={this.state.exam_end_date_moment}
                                        onChange={this.handleDatepickerEndChange}
                                        dateFormat="DD-MM-YYYY HH:mm"
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                    />
                                </div>
                            </div>
                            <InputView
                                handleChange={this.handleChange}
                                stateName="exam_time_limit"
                                label="Waktu (Dalam Menit)"
                                value={this.state.exam_time_limit}
                                type="number"
                                style={{width: "195px", display: "inline"}}
                            />
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">
                                    Kelas
                                </label>
                                <div className="col-md-10">
                                    <Select
                                        multi
                                        value={this.state.participants}
                                        onChange={text =>
                                            this.handleChangeMultiSelect("participants", text)
                                        }
                                        options={this.state.dataKelas}
                                        placeholder="- Pilih Kelas"
                                        removeSelected={this.state.removeSelected}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Status</label>
                                <div className="col-md-4">
                                    <FormDropdown
                                        placeholder={"- Pilih Status"}
                                        items={status_aktif}
                                        onChange={this.handleChange}
                                        value={this.state.exam_status}
                                        name="exam_status"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Tampilkan Nilai</label>
                                <div className="col-md-4">
                                    <Switch
                                        onChange={(e)=>this.handleChangeSwitch(e,'showNilai')}
                                        checked={this.state.showNilai}
                                        className="react-switch"
                                        name="showNilai"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-2 form-control-label">Tampilkan Jawaban</label>
                                <div className="col-md-4">
                                    <Switch
                                        name="showResult"
                                        onChange={(e)=>this.handleChangeSwitch(e,'showResult')}
                                        checked={this.state.showResult}
                                        className="react-switch"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="card-footer">
                    <button
                        type="button"
                        className="btn btn-md btn-primary"
                        disabled={this.state.isButtonLoading && "disabled"}
                        onClick={this.handleSubmit}
                    >
                        {this.state.isButtonLoading ? "Loading" : "Simpan"}
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user_id: state.authReducer.user_id
});

export default connect(mapStateToProps)(Forms);



// WEBPACK FOOTER //
// ./src/views/Exam/Schedule/Forms.js